import { z } from 'zod';
import { FormField } from '../../../dynamic-form.types';

export const buildTextFieldSchema = (field: FormField) => {
  const isRequired = field.rules.required.value ?? false;
  const errorMessage = field.rules.required.copy;

  if (isRequired) {
    return z.preprocess(
      (val) => (val === null || val === undefined ? '' : val),
      z.string().min(1, {
        message: errorMessage,
      })
    );
  } else {
    return z.string().optional();
  }
};
